import { useSelector, useDispatch } from 'react-redux';

import Chart from 'react-apexcharts';

import arrowDown from '../assets/down-arrow.svg';
import arrowUp from '../assets/up-arrow.svg';
import metamaskLogo from '../assets/metamask.png';

import { options, defaultSeries } from './PriceChart.config';

import { priceChartSelector } from '../store/selectors';


const TIMEFRAMES = ['1m', '5m', '1h', '1D']

const PriceChart = () => {
  const dispatch = useDispatch()
  const account = useSelector(state => state.provider.account)
  const symbols = useSelector(state => state.tokens.symbols)
  const chartTimeframe = useSelector(state => state.exchange.chartTimeframe)
  const priceChart = useSelector(priceChartSelector)

  return (
    <div className="component exchange__chart">
      <div className='component__header flex-between'>
        <div className='flex'>

          <h2>{symbols && symbols[0] && symbols[1] ? `${symbols[0]}/${symbols[1]}` : 'Chart'}</h2>

          {priceChart && (

            <div className='flex'>

              {priceChart.lastPriceChange === '+' ? (
                <img src={arrowUp} alt="Arrow up" />
              ): (
                <img src={arrowDown} alt="Arrow down" />
              )}

              <span className='up'>{priceChart.lastPrice}</span>
            </div>

          )}

        </div>
        <div className="chart-tf">
          {TIMEFRAMES.map((tf) => (
            <button
              key={tf}
              className={`chart-tf__btn${chartTimeframe === tf ? ' chart-tf__btn--active' : ''}`}
              onClick={() => dispatch({ type: 'CHART_TIMEFRAME_SET', timeframe: tf })}
            >
              {tf}
            </button>
          ))}
        </div>
      </div>

      {!account ? (
        <div className="chart-placeholder">
          <svg className="chart-placeholder__candles" viewBox="0 0 340 140" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* Grid lines */}
            <line x1="0" y1="35" x2="340" y2="35" stroke="var(--clr-border)" strokeWidth="0.5" strokeDasharray="4 4" />
            <line x1="0" y1="70" x2="340" y2="70" stroke="var(--clr-border)" strokeWidth="0.5" strokeDasharray="4 4" />
            <line x1="0" y1="105" x2="340" y2="105" stroke="var(--clr-border)" strokeWidth="0.5" strokeDasharray="4 4" />

            {/* Candle 1 — green, starting low */}
            <g className="chart-placeholder__candle chart-placeholder__candle--1">
              <line x1="30" y1="70" x2="30" y2="120" stroke="var(--clr-green)" strokeWidth="1.5" strokeLinecap="round" className="chart-placeholder__wick" />
              <rect x="23" y="80" width="14" height="25" rx="2" fill="var(--clr-green)" className="chart-placeholder__body" />
            </g>

            {/* Candle 2 — green, moving up */}
            <g className="chart-placeholder__candle chart-placeholder__candle--2">
              <line x1="65" y1="55" x2="65" y2="110" stroke="var(--clr-green)" strokeWidth="1.5" strokeLinecap="round" className="chart-placeholder__wick" />
              <rect x="58" y="65" width="14" height="28" rx="2" fill="var(--clr-green)" className="chart-placeholder__body" />
            </g>

            {/* Candle 3 — green, higher */}
            <g className="chart-placeholder__candle chart-placeholder__candle--3">
              <line x1="100" y1="38" x2="100" y2="95" stroke="var(--clr-green)" strokeWidth="1.5" strokeLinecap="round" className="chart-placeholder__wick" />
              <rect x="93" y="48" width="14" height="30" rx="2" fill="var(--clr-green)" className="chart-placeholder__body" />
            </g>

            {/* Candle 4 — small red dip */}
            <g className="chart-placeholder__candle chart-placeholder__candle--4">
              <line x1="135" y1="42" x2="135" y2="88" stroke="var(--clr-red)" strokeWidth="1.5" strokeLinecap="round" className="chart-placeholder__wick" />
              <rect x="128" y="50" width="14" height="22" rx="2" fill="var(--clr-red)" className="chart-placeholder__body" />
            </g>

            {/* Candle 5 — green, peak */}
            <g className="chart-placeholder__candle chart-placeholder__candle--5">
              <line x1="170" y1="12" x2="170" y2="75" stroke="var(--clr-green)" strokeWidth="1.5" strokeLinecap="round" className="chart-placeholder__wick" />
              <rect x="163" y="22" width="14" height="32" rx="2" fill="var(--clr-green)" className="chart-placeholder__body" />
            </g>

            {/* Candle 6 — red, starting down */}
            <g className="chart-placeholder__candle chart-placeholder__candle--6">
              <line x1="205" y1="18" x2="205" y2="82" stroke="var(--clr-red)" strokeWidth="1.5" strokeLinecap="round" className="chart-placeholder__wick" />
              <rect x="198" y="32" width="14" height="30" rx="2" fill="var(--clr-red)" className="chart-placeholder__body" />
            </g>

            {/* Candle 7 — red, lower */}
            <g className="chart-placeholder__candle chart-placeholder__candle--7">
              <line x1="240" y1="35" x2="240" y2="100" stroke="var(--clr-red)" strokeWidth="1.5" strokeLinecap="round" className="chart-placeholder__wick" />
              <rect x="233" y="48" width="14" height="32" rx="2" fill="var(--clr-red)" className="chart-placeholder__body" />
            </g>

            {/* Candle 8 — small green bounce */}
            <g className="chart-placeholder__candle chart-placeholder__candle--8">
              <line x1="275" y1="45" x2="275" y2="105" stroke="var(--clr-green)" strokeWidth="1.5" strokeLinecap="round" className="chart-placeholder__wick" />
              <rect x="268" y="58" width="14" height="24" rx="2" fill="var(--clr-green)" className="chart-placeholder__body" />
            </g>

            {/* Candle 9 — red, finishing low */}
            <g className="chart-placeholder__candle chart-placeholder__candle--9">
              <line x1="310" y1="55" x2="310" y2="125" stroke="var(--clr-red)" strokeWidth="1.5" strokeLinecap="round" className="chart-placeholder__wick" />
              <rect x="303" y="68" width="14" height="35" rx="2" fill="var(--clr-red)" className="chart-placeholder__body" />
            </g>
          </svg>
          <div className="chart-placeholder__cta">
            <img src={metamaskLogo} alt="MetaMask" className="chart-placeholder__metamask" />
            <p className="chart-placeholder__text">Connect to MetaMask to view chart</p>
          </div>
        </div>
      ) : (
        <Chart
          type="candlestick"
          options={options}
          series={priceChart ? priceChart.series : defaultSeries }
          width="100%"
          height="100%"
        />
      )}

    </div>
  );
}

export default PriceChart;